"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.cartPricesAsOf = cartPricesAsOf;
exports.isMissingPrice = isMissingPrice;
exports.dealMatchesPrice = dealMatchesPrice;
function knownTime(time) {
    return typeof time === 'number' && Number.isFinite(time) && time > 0 ? time : undefined;
}
function cartPricesAsOf(cart) {
    var _a;
    const saved = knownTime(cart === null || cart === void 0 ? void 0 : cart.timestamp);
    const items = (_a = cart === null || cart === void 0 ? void 0 : cart.items) !== null && _a !== void 0 ? _a : [];
    const times = items.length > 0 ? items.map((item) => { var _a; return (_a = knownTime(item === null || item === void 0 ? void 0 : item.priceAsOf)) !== null && _a !== void 0 ? _a : saved; }) : [saved];
    return times.reduce((oldest, time) => (time === undefined ? oldest : oldest === undefined ? time : Math.min(oldest, time)), undefined);
}
// A cart stores a missing price as '-1', '-1.0', '-1.00' or the number -1.
function isMissingPrice(price) {
    return Number(price) === -1;
}
function dealMatchesPrice(dealPrice, rowPrice) {
    const row = typeof rowPrice === 'number' ? rowPrice : Number.parseFloat(String(rowPrice !== null && rowPrice !== void 0 ? rowPrice : ''));
    return typeof dealPrice === 'number' && Number.isFinite(dealPrice) && Number.isFinite(row) && row > 0 && Math.round(dealPrice * 100) === Math.round(row * 100);
}
